/** Keep application id as string so hooks + ApplicationNotes share one React Query cache entry. */
export const APPLICATION_NOTES_QUERY_ROOT = 'applicationNotes' as const;

/**
 * Keep notes warm across candidate ‹ › navigation (5 min). Creating/editing a
 * note invalidates the notes cache key, so authored changes still refetch.
 */
export const APPLICATION_NOTES_STALE_MS = 5 * 60 * 1000;

export function applicationNotesQueryKey(
  applicationId: string | number | null | undefined,
  page: number
): readonly [typeof APPLICATION_NOTES_QUERY_ROOT, string, number] {
  const id =
    applicationId === undefined ||
    applicationId === null ||
    applicationId === ''
      ? ''
      : String(applicationId);
  return [APPLICATION_NOTES_QUERY_ROOT, id, page];
}
